import React, { useEffect, useState } from 'react';
import shortid from 'shortid';
import { Survey_Component } from '../../../components/ATQAdministrator/ATQAdministrator_Survey/Survey_Component';
import { SubNavBarComponent } from '../../../components/layouts/layout1/subnavbar/SubNavBarComponent';
import { ATQ_Individual_Compo } from '../../../components/ATQ/ATQ_ENCUESTA/ATQ_Individual_Compo';
import { StoreHouseListComponent } from '../../../components/StoreHouseComponents/StoreHouseApproveStatusComponent/StoreHouseListComponent';
import { TableUbication_Component } from '../../../components/ATQAdministrator/ATQAdministrator_Survey/TableUbication_Component';
import icoAdd from '../../../assets/img/126PX/IcoAgregarCi.png';
import iconDel from '../../../assets/img/126PX/iconDeleteComp.png';

import './styles.scss';
import { useHistory, useParams } from 'react-router-dom';
import { Survey_Medico_Component } from '../../../components/StoreHouseComponents/StoreHouseReiceivingEncuestasComponents/Survey_Medico_Component';
import { useDispatch, useSelector } from 'react-redux';
import { getAppointmentLocationsStoreHose, getAppointmentLocationsStoreHoseSuccess, getProductsToAppointmentStoreHose, getProductsToAppointmentStoreHoseSuccess, setAppointmentsStoreHouse } from '../../../actions/storeHouseAction';
import { handleCompleteBeginLocations, handleCompleteBeginProducts } from '../../../hooks/useFunctionsStoreHouse';
import { surveySetCommetWareHouse, surveyWareHouse } from '../../../actions/surveyAction';



export const StoreHomeReceivingEncuestasScreen = () => {

    const [componentText, setComponentText] = useState(false);
    const { activeSwitch, id } = useParams();
    const [encuestasMedico, setEncuestasMedico] = useState(false);
    const surveyID = useSelector(state => state.survey.setSurveyAppoimentSelected.surgeryAppointment)
    const dispatch = useDispatch();
    const history = useHistory();
    const surveySele = useSelector(state => state.survey.setSurveyAppoimentSelected);
    const AppointmentProducts = useSelector(state => state.storeHouse.AppointmentProducts);
    const AppointmentLocations = useSelector(state => state.storeHouse.AppointmentLocations);
    const AppointmentWithLocations = useSelector(state => state.storeHouse.appointmentItem);
    const [newProductsReq, setNewProductsReq] = useState(null);

    const [newCommentSurvey, setNewCommentSurvey] = useState({
        Commentary: "",
    })
    const [valueWareHouse, setValueWareHouse] = useState({
        CheckInCommentary: "",
        CheckOutCommentary: "",
        CoordinatorCommentary: ""
    })

    useEffect(() => {
        if (surveyID && surveyID.id) {
            dispatch(getProductsToAppointmentStoreHose(surveyID.id))
            dispatch(getAppointmentLocationsStoreHose(surveyID.id))
        }
        return () => {
            dispatch(setAppointmentsStoreHouse(null));
            dispatch(getAppointmentLocationsStoreHoseSuccess(null))
            dispatch(getProductsToAppointmentStoreHoseSuccess(null))
        }
    }, [])

    useEffect(() => {
        if (AppointmentLocations) {
            handleCompleteBeginLocations(AppointmentLocations, setNewProductsReq, surveyID)
        }
    }, [, AppointmentLocations])

    useEffect(() => {

        if ((!_.isNil(AppointmentProducts) && AppointmentProducts.length > 0 && AppointmentProducts != null) || (newProductsReq != null)) {
            {
                if (!AppointmentWithLocations || AppointmentWithLocations === null) {
                    dispatch(setAppointmentsStoreHouse(handleCompleteBeginProducts(AppointmentProducts, newProductsReq, surveyID)));
                }
            }
        }

    }, [newProductsReq])

    const arrayListFields = [
        {
            uid: shortid.generate(),
            title: 'Medico',
            value: (surveyID && surveyID.medic) &&
                (surveyID.medic && surveyID.medic.name && surveyID.medic.name) + ' ' +
                (surveyID.medic && surveyID.medic.secondName && surveyID.medic.secondName) + ' ' +
                (surveyID.medic && surveyID.medic.firstLastname && surveyID.medic.firstLastname) + ' ' +
                (surveyID.medic && surveyID.medic.secondLastname && surveyID.medic.secondLastname),
        },
        {
            uid: shortid.generate(),
            title: 'Institucion',
            value: (surveyID && surveyID.hospital && surveyID.hospital.name),
        },
        {
            uid: shortid.generate(),
            title: 'Fecha y Hora',
            type: 'DATE-COMPLETE',
            value: (surveyID && surveyID.surgeryDate),
        },
        {
            uid: shortid.generate(),
            title: 'ATQ',
            value: (surveyID && surveyID.atq ?
                `${surveyID.atq.firstName && surveyID.atq.firstName} ${surveyID.atq.secondName && surveyID.atq.secondName}
                 ${surveyID.atq.firstLastName && surveyID.atq.firstLastName} `
                : 'ATQ NO ASIGNADO'),
        },
    ];

    const handleSendData = async () => {
        const resultado = await dispatch(surveyWareHouse(valueWareHouse, parseInt(id)))
        if (resultado === true) {
            history.push(`/Quality_Messages_Page/${id}`);
        }
    }


    // useEffect(() => {
    //  console.warn("aaa",componentText)
    // }, [componentText])

    const handleAceptar = async () => {
        if (newCommentSurvey.Commentary.length > 0) {
            const resultado = await dispatch(surveySetCommetWareHouse(newCommentSurvey, parseInt(surveySele.warehouseSurvey.id)));
            if (componentText === true) {
                //console.log("con comentario agregado")
                history.push(`/Quality_Messages_Page_notificacion/${id}`)
            }
        }
        if (!componentText) {
            history.push(`/Encuestas`);
        }

    }
    return (
        <div className="container-encuestas-screen">
            <SubNavBarComponent title={'Encuestas'} historyPage={`/Encuestas`} />
            <div className="container-encuestas-colums">
                <section >
                    <StoreHouseListComponent
                        typeView={{ title: `CX #${id}`, type: 'STORE', }}
                        listFields={arrayListFields}
                    />

                    <TableUbication_Component
                        listItemsBody={AppointmentWithLocations && AppointmentWithLocations.productRequirements && AppointmentWithLocations.productRequirements.length > 0 ? AppointmentWithLocations.productRequirements : null}
                    />
                </section>

                <div className="precontainer-encuestas_survey">

                    <div className="container-encuestas_survey">
                        <div className='container-bttns'>
                            <button className='btn-encuestas' style={encuestasMedico === false ? { background: 'linear-gradient(90deg, #094070 0%, #1abc9c 100%)' } : {}} onClick={() => setEncuestasMedico(false)}>ENCUESTA ATQ</button>
                            <button className='btn-encuestas' style={encuestasMedico === true ? { background: 'linear-gradient(90deg, #094070 0%, #1abc9c 100%)' } : {}} onClick={() => setEncuestasMedico(true)}>ENCUESTA MÉDICO</button>
                        </div>
                        {
                            encuestasMedico === false

                                ? <Survey_Component
                                    titulo={'Seguimineto para uso interno de TSI'}
                                    tipo={'atq'}
                                />
                                :
                                <Survey_Medico_Component
                                    titulo={'Seguimineto para uso interno de TSI'}
                                    tipo={'medico-almacen'}
                                //
                                />
                        }
                        {activeSwitch === 'ACTIVE'
                            ? <>
                                <div className='individual-container-encuestas'>
                                    <ATQ_Individual_Compo
                                        titulo={'Entrada Almacen'}
                                        tipo={'Entrada Almacen'}
                                        valueWareHouse={valueWareHouse}
                                        setValueWareHouse={setValueWareHouse}
                                    />
                                </div>
                                <div className='individual-container-encuestas'>
                                    <ATQ_Individual_Compo
                                        titulo={'Salida Almacen'}
                                        tipo={'Salida Almacen'}
                                        valueWareHouse={valueWareHouse}
                                        setValueWareHouse={setValueWareHouse}
                                    />
                                </div>
                                <div className='individual-container-encuestas'>
                                    <ATQ_Individual_Compo
                                        titulo={'Coordinador Almacen'}
                                        tipo={'Coordinador Almacen'}
                                        valueWareHouse={valueWareHouse}
                                        setValueWareHouse={setValueWareHouse}
                                    />
                                </div>
                                <div className='container-btn'>
                                    <button className='btn-Aceptar' onClick={handleSendData}>
                                        <p className='btn-title'>GUARDAR</p>
                                    </button>
                                </div>
                            </>
                            :
                            <>
                                <div className='individual-container-encuestas'>
                                    <ATQ_Individual_Compo
                                        titulo={'Entrada Almacen'}
                                        tipo={'Almacen'}
                                        comentario={surveySele.warehouseSurvey.checkInCommentary ? surveySele.warehouseSurvey.checkInCommentary : 'Se agregara comentario entrada almacenen'}
                                        valueWareHouse={valueWareHouse}
                                        setValueWareHouse={setValueWareHouse}


                                    />
                                </div>
                                <div className='individual-container-encuestas'>
                                    <ATQ_Individual_Compo
                                        titulo={'Salida Almacen'}
                                        tipo={'Almacen'}
                                        comentario={surveySele.warehouseSurvey.checkOutCommentary ? surveySele.warehouseSurvey.checkOutCommentary : 'se agregara comentario salida almacen'}
                                        valueWareHouse={valueWareHouse}
                                        setValueWareHouse={setValueWareHouse}
                                    />
                                </div>
                                <div className='individual-container-encuestas'>
                                    <ATQ_Individual_Compo
                                        titulo={'Coordinador Almacen'}
                                        tipo={'Agregado'}
                                        disabled
                                        comentario={surveySele.warehouseSurvey.coordinatorCommentary ? surveySele.warehouseSurvey.coordinatorCommentary : 'se agregara comentario coordinador almacen'}
                                    />
                                </div>
                                {
                                    surveySele.warehouseSurvey && surveySele.warehouseSurvey.commentaries.length > 0 &&
                                    surveySele.warehouseSurvey.commentaries.map(item => (
                                        <div key={shortid.generate} className='individual-container_New'>
                                            <ATQ_Individual_Compo
                                                titulo={'Comentarios Agregados'}
                                                tipo={'Agregado'}
                                                comentario={item.description && item.description}

                                            />
                                        </div>
                                    ))
                                }
                            </>
                        }

                    </div>

                    {activeSwitch === "INACTIVE" &&
                        <>

                            {componentText === true &&
                                <div className='individual-container-atq_New'>
                                    <ATQ_Individual_Compo
                                        titulo={'Agregar nuevo comentrio'}
                                        tipo={'Nuevo'}
                                        newCommentSurvey={newCommentSurvey}
                                        setNewCommentSurvey={setNewCommentSurvey}
                                    />
                                </div>
                            }

                            {componentText === true

                                ? <div className='container-atq-buttons-add'><img className='icoAdd' src={iconDel} onClick={() => setComponentText(!componentText)} />
                                </div>
                                : <div className='container-atq-buttons-add'><img className='icoAdd' src={icoAdd} onClick={() => setComponentText(!componentText)} />
                                </div>
                            }
                            <div className='container-btn'>
                                <button className='btn-Aceptar' onClick={() => handleAceptar()}>
                                    <p className='btn-title'>ACEPTAR</p>
                                </button>
                            </div>
                        </>

                    }

                </div>
            </div>
        </div>
    )
}

